<script setup>
import BaseLazyImage from '~/components/BaseLazyImage'
import GooglePlayBadge from '~/assets/icons/google-play-badge.svg'
import AppStoreBadge from '~/assets/icons/app-store-badge.svg'
import BCIcon from '~/assets/icons/bc-icon.svg'

const config = useRuntimeConfig()
const imageUrl = config.public.IMAGE_RESIZE_URL
const src = `${imageUrl}?image=fe-assets/promo-on-every-device.png`
const sources = `
    ${src}&width=520&height=490&fit=contain 1000w,
    ${src}&width=1040&height=980&fit=contain 1500w,
    ${src}&width=1722&height=1170&fit=contain 1800w`
</script>

<template>
  <div class="on-every-device position-relative overflow-hidden">
    <BCIcon class="bc-icon" />
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="col-10 text-center mb-48">
          <h2 class="mb-16">
            {{ $label('page.everyDevice.title') }}
          </h2>
          <p class="mb-0">{{ $label('page.everyDevice.text') }}</p>
        </div>
        <div class="col-12 col-lg-10 d-flex justify-content-center">
          <BaseLazyImage
            :src="`${src}&width=861&height=585&fit=contain`"
            :srcset="sources"
            fluid
            :width="861"
            :height="585"
            placeholder-color="transparent"
          />
        </div>
        <div class="col-12 col-lg-10 offset-xl-1 offset-xxl-2">
          <div
            class="on-every-device__app-badges d-flex align-items-center flex-wrap"
          >
            <a
              id="googlePlay"
              :href="$label('page.myBooks.appPromoBanner.googlePlayLink')"
              target="_blank"
            >
              <GooglePlayBadge width="160" height="48" />
            </a>

            <a
              :href="$label('page.myBooks.appPromoBanner.appleStoreLink')"
              target="_blank"
            >
              <AppStoreBadge width="160" height="48" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.on-every-device {
  background-color: $grey-01;
  padding: 56px 16px 92px;
  z-index: 1;
}

.bc-icon {
  position: absolute;
  z-index: -1;
  fill: $grey-02;
  width: 216vw;
  transform: rotate(71.63deg) translate(-1%, 15%);
}

.on-every-device__app-badges {
  gap: 8px;
  margin-top: -5vw;
  padding-left: 6vw;

  svg {
    width: 15.9vw;
    height: auto;
  }
}

@include media-breakpoint-up(lg) {
  .on-every-device {
    padding: 96px 16px 92px;
  }

  .bc-icon {
    max-width: 2691.53px;
    transform: rotate(71.63deg) translate(-17.5%, -3.6%);
  }

  .on-every-device__app-badges {
    margin-top: -40px;
    padding-left: 56px;

    svg {
      width: 146px;
      height: auto;
    }
  }
}
</style>
